import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NavbarComponent,
    SidebarComponent
  ],
  template: `
    <div class="bg-gray-50 h-full">
        <div class="fixed top-0 left-0 right-0 z-50">
            <app-navbar >
            </app-navbar>
        </div>
      
        <div class="fixed left-0 right-0 z-40 h-full bg-blue-900 w-60 hidden md:block sidebar-dark">
            <div class="pt-16">
                <app-sidebar>
                </app-sidebar>
            </div>
        </div>
        <div class="bg-gray-100 h-full overflow-y-auto">
            <div class="md:pl-65 md:pr-10 px-5 pt-20">
                <router-outlet />
            </div>
        </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100vh;
    }
  `]
})
export class LayoutComponent {
  private router = inject(Router);
  sidebarVisible = signal(true);

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (!event.url.includes('/auth/') && !event.url.includes('/public/')) {
        const urlWithParams = event.urlAfterRedirects || event.url;
        localStorage.setItem('lastVisitedUrl', urlWithParams);
      }
    });
  }

  toggleSidebar() {
    this.sidebarVisible.update(visible => !visible);
  }

  onSidebarVisibilityChange(visible: boolean) {
    this.sidebarVisible.set(visible);
  }
} 